export const DEFAULT_CONSTANTS = null;

export default {
  DEFAULT_CONSTANTS,
};
